import React from 'react';
import {Box, Grid, Typography} from '@mui/material';

type AurDrawerHeaderProps = {
  buttons: React.ReactNode[];
  title: string;
  titleCssClass?: string;
  subtitle?: string;
};

const AurDrawerHeader = (props: AurDrawerHeaderProps) => {
  return (
    <Box>
      <Grid container>
        <Grid item xs={6}>
          <Box className={'left-align-center-y'}>
            <Typography
              className={
                props.titleCssClass
                  ? props.titleCssClass + ' drawer-header-title'
                  : 'drawer-header-title'
              }
              tabIndex={0}
            >
              {props.title}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box className={'right-align-center-y'}>
            {props.buttons.map((value) => (
              <>{value}</>
            ))}
          </Box>
        </Grid>
        <Typography className="typo-text body3_size color-mist-400 aur-drawer-header-subtitle">
          {props.subtitle}
        </Typography>
      </Grid>
    </Box>
  );
};

export default AurDrawerHeader;
